"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _MXJUUCSDcjs = require('./MXJUUCSD.cjs');


var _6P52IAFYcjs = require('./6P52IAFY.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/popover/popover-dismiss.tsx
var TagName = "button";
var usePopoverDismiss = _PTOCUU2Dcjs.createHook.call(void 0, 
  function usePopoverDismiss2({ store, ...props }) {
    const context = _6P52IAFYcjs.usePopoverScopedContext.call(void 0, );
    store = store || context;
    props = _MXJUUCSDcjs.useDialogDismiss.call(void 0, { store, ...props });
    return props;
  }
);
var PopoverDismiss = _PTOCUU2Dcjs.forwardRef.call(void 0, function PopoverDismiss2(props) {
  const htmlProps = usePopoverDismiss(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.usePopoverDismiss = usePopoverDismiss; exports.PopoverDismiss = PopoverDismiss;
